export const countriesArray = [
  {
    name: "belgium",
    url:
      "https://www.google.com/maps/place/Belgium/@50.4795318,2.2235539,7z/data=!3m1!4b1!4m5!3m4!1s0x47c17d64edf39797:0x47ebf2b439e60ff2!8m2!3d50.503887!4d4.469936"
  },
  {
    name: "bosnia",
    url:
      "https://www.google.co.uk/maps/place/Bosnia+and+Herzegovina/data=!4m2!3m1!1s0x134ba215c737a9d7:0x6df7e20343b7e90c?sa=X&ved=2ahUKEwiogu3Km-HpAhWionIEHRatD7gQ8gEwIHoECBQQBg"
  },
  {
    name: "cambodia",
    url:
      "https://www.google.co.uk/maps/place/Cambodia/data=!4m2!3m1!1s0x310787bfd4dc3743:0xe4b7bfe089f41253?sa=X&ved=2ahUKEwisn_fem-HpAhXelnIEHfa6AFIQ8gEwJnoECBcQBg"
  },
  {
    name: "canada",
    url:
      "https://www.google.co.uk/maps/place/Canada/data=!4m2!3m1!1s0x4b0d03d337cc6ad9:0x9968b72aa2438fa5?sa=X&ved=2ahUKEwiJlNj6m-HpAhVUg3IEHUbWCL0Q8gEwIXoECBkQBg"
  },
  {
    name: "china",
    url:
      "https://www.google.co.uk/maps/place/China/@34.4549159,86.0758081,4z/data=!3m1!4b1!4m5!3m4!1s0x31508e64e5c642c1:0x951daa7c349f366f!8m2!3d35.86166!4d104.195397o"
  },
  {
    name: "colombia",
    url:
      "https://www.google.co.uk/maps/place/Colombia/data=!4m2!3m1!1s0x8e15a43aae1594a3:0x9a0d9a04eff2a340?sa=X&ved=2ahUKEwjKrqnAnOHpAhXhg3IEHRxZAUAQ8gEwJnoECBcQBg"
  },
  {
    name: "croatia",
    url:
      "https://www.google.co.uk/maps/place/Croatia/data=!4m2!3m1!1s0x133441080add95ed:0xa0f3c024e1661b7f?sa=X&ved=2ahUKEwiAopPQnOHpAhU2lXIEHa9JAG8Q8gEwHnoECBYQBg"
  },
  {
    name: "cyprus",
    url:
      "https://www.google.co.uk/maps/place/Cyprus/@35.1636347,32.3040171,8z/data=!3m1!4b1!4m5!3m4!1s0x14de1767ca494d55:0x324c3c807fc4146e!8m2!3d35.126413!4d33.429859"
  },
  {
    name: "denmark",
    url:
      "https://www.google.co.uk/maps/place/Denmark/@56.1488816,7.0586993,6z/data=!3m1!4b1!4m5!3m4!1s0x464b27b6ee945ffb:0x528743d0c3e092cd!8m2!3d56.26392!4d9.501785"
  },
  {
    name: "england",
    url:
      "https://www.google.co.uk/maps/place/England/data=!4m2!3m1!1s0x47d0a98a6c1ed5df:0xf4e19525332d8ea8?sa=X&ved=2ahUKEwi-95b_nOHpAhUmmXIEHaR7ChIQ8gEwJnoECBcQBg"
  },
  {
    name: "france",
    url:
      "https://www.google.co.uk/maps/place/France/data=!4m2!3m1!1s0xd54a02933785731:0x6bfd3f96c747d9f7?sa=X&ved=2ahUKEwjnjOKKneHpAhV2hHIEHac-AxQQ8gEwKHoECBgQBg"
  },
  {
    name: "germany",
    url:
      "https://www.google.co.uk/maps/place/Germany/data=!4m2!3m1!1s0x479a721ec2b1be6b:0x75e85d6b8e91e55b?sa=X&ved=2ahUKEwim_oqnneHpAhWEoHIEHeiaDngQ8gEwKHoECBcQBg"
  },
  {
    name: "greece",
    url:
      "https://www.google.co.uk/maps/place/Greece/data=!4m2!3m1!1s0x135b4ac711716c63:0x363a1775dc9a2d1d?sa=X&ved=2ahUKEwjo1Iu0neHpAhVrhXIEHQyfAJoQ8gEwKHoECBcQBg"
  },
  {
    name: "hungary",
    url:
      "https://www.google.co.uk/maps/place/Hungary/data=!4m2!3m1!1s0x4741837bdf37e4c3:0xc4290c1e1010?sa=X&ved=2ahUKEwizqqPEneHpAhUjmXIEHdZ6AYAQ8gEwJXoECBUQBg"
  },
  {
    name: "ireland",
    url:
      "https://www.google.co.uk/maps/place/Ireland/@53.3623854,-10.4601123,7z/data=!3m1!4b1!4m5!3m4!1s0x4859bae45c4027fb:0xcf7c1234cedbf408!8m2!3d53.41291!4d-8.24389"
  },
  {
    name: "italy",
    url:
      "https://www.google.co.uk/maps/place/Italy/@40.9401583,3.7241571,5z/data=!3m1!4b1!4m5!3m4!1s0x12d4fe82448dd203:0xe22cf55c24635e6f!8m2!3d41.87194!4d12.56738"
  },
  {
    name: "laos",
    url:
      "https://www.google.co.uk/maps/place/Laos/@18.1570195,99.3626821,6z/data=!3m1!4b1!4m5!3m4!1s0x31149057b0824589:0xec592481f99cd81!8m2!3d19.85627!4d102.495496"
  },
  {
    name: "myanmar",
    url:
      "https://www.google.co.uk/maps/place/Myanmar+(Burma)/@18.7807572,87.6372642,5z/data=!3m1!4b1!4m5!3m4!1s0x305652a7714e2907:0xba7b0ee41c622b11!8m2!3d21.916221!4d95.955974"
  },
  {
    name: "netherlands",
    url:
      "https://www.google.co.uk/maps/place/Netherlands/@52.191735,3.0369282,7z/data=!3m1!4b1!4m5!3m4!1s0x47c609c3db87e4bb:0xb3a175ceffbd0a9f!8m2!3d52.132633!4d5.291266"
  },
  {
    name: "north-korea",
    url:
      "https://www.google.co.uk/maps/place/North+Korea/@40.2135478,122.9341875,6z/data=!3m1!4b1!4m5!3m4!1s0x357e02dae64f4337:0x3a0b871c3e1d861c!8m2!3d40.339852!4d127.510093"
  },
  {
    name: "poland",
    url:
      "https://www.google.co.uk/maps/place/Poland/@51.8684183,14.6489197,6z/data=!3m1!4b1!4m5!3m4!1s0x47009964a4640bbb:0x97573ca49cc55ea!8m2!3d51.919438!4d19.145136"
  },
  {
    name: "portugal",
    url:
      "https://www.google.co.uk/maps/place/Portugal/@37.1458837,-23.3169862,6z/data=!3m1!4b1!4m5!3m4!1s0xb32242dbf4226d5:0x2ab84b091c4ef041!8m2!3d39.399872!4d-8.224454"
  },
  {
    name: "scotland",
    url:
      "https://www.google.co.uk/maps/place/Scotland/@57.6677015,-9.1705585,6z/data=!3m1!4b1!4m5!3m4!1s0x4861e2c403f2a19f:0xe7c1fad809c30714!8m2!3d56.4906712!4d-4.2026458"
  },
  {
    name: "serbia",
    url:
      "https://www.google.co.uk/maps/place/Serbia/@44.1927644,18.6796324,7z/data=!3m1!4b1!4m5!3m4!1s0x47571ddff2898095:0x55e50ea3723865d!8m2!3d44.016521!4d21.005859"
  },
  {
    name: "slovenia",
    url:
      "https://www.google.co.uk/maps/place/Slovenia/data=!4m2!3m1!1s0x476524e75e968361:0xe740451e25e2d465?sa=X&ved=2ahUKEwjVxqavn-HpAhVEgXIEHZgTB_AQ8gEwIHoECBYQBg"
  },
  {
    name: "spain",
    url:
      "https://www.google.co.uk/maps/place/Spain/@39.8596584,-12.7036393,5z/data=!3m1!4b1!4m5!3m4!1s0xc42e3783261bc8b:0xa6ec2c940768a3ec!8m2!3d40.463667!4d-3.74922"
  },
  {
    name: "sweden",
    url:
      "https://www.google.co.uk/maps/place/Sweden/data=!4m2!3m1!1s0x465cb2396d35f0f1:0x22b8eba28dad6f62?sa=X&ved=2ahUKEwjI-ZDMn-HpAhXsgnIEHc5EA9gQ8gEwHnoECBgQBg"
  },
  {
    name: "thailand",
    url:
      "https://www.google.co.uk/maps/place/Thailand/@13.0003076,96.992706,6z/data=!3m1!4b1!4m5!3m4!1s0x304d8df747424db1:0x9ed72c880757e802!8m2!3d15.870032!4d100.992541"
  },
  {
    name: "ukraine",
    url:
      "https://www.google.co.uk/maps/place/Ukraine/@47.9854715,22.2083201,5z/data=!3m1!4b1!4m5!3m4!1s0x40d1d9c154700e8f:0x1068488f64010!8m2!3d48.379433!4d31.1655799"
  },
  {
    name: "usa",
    url:
      "https://www.google.co.uk/maps/place/United+States/@36.2502904,-113.6966499,4z/data=!3m1!4b1!4m5!3m4!1s0x54eab584e432360b:0x1c3bb99243deb742!8m2!3d37.09024!4d-95.712891"
  },
  {
    name: "vietnam",
    url:
      "https://www.google.co.uk/maps/place/Vietnam/@15.7583479,101.4148807,6z/data=!3m1!4b1!4m5!3m4!1s0x31157a4d736a1e5f:0xb03bb0c9e2fe62be!8m2!3d14.058324!4d108.277199"
  },
  {
    name: "wales",
    url:
      "https://www.google.co.uk/maps/place/Wales/@52.3841116,-6.4023773,7z/data=!3m1!4b1!4m5!3m4!1s0x486434b66c1c0fed:0x1ebb71bc8aa5e8a2!8m2!3d52.1306607!4d-3.7837117"
  }
];
